import { ICommandBase } from '@/commands/interface/iCommandBase';
import { PatternBaseLayer } from '@/model/document2/page/surface/design/layer/patternBaseLayer';
import { ColorConstruct } from '@/utilityModels/colorConstruct';

// 図形のグラデーション削除コマンド
export class RemoveGradationOfPatternCommand implements ICommandBase
{
    private layer! : PatternBaseLayer;
    private index! : number;
    private doneCallback! : () => void;

    private position : number = 0;
    private color : ColorConstruct = new ColorConstruct();

    constructor(layer : PatternBaseLayer, index : number, doneCallback : () => void)
    {
        this.layer = layer;
        this.index = index;
        this.doneCallback = doneCallback;

        var grad = this.layer.getGradation(index);
        this.position = grad.position;
        this.color = grad.color;
    }

    public do() : void
    {
        // グラデーション削除
        this.layer.removeGradation(this.index);
        // カレントは直前に
        var newSelectedIndex = this.index - 1;
        if(newSelectedIndex < 0) { newSelectedIndex = 0; }
        this.layer.selectedGradationPoint = newSelectedIndex;

        this.doneCallback();
    }

    public undo() : void
    {
        // グラデーション追加
        this.index = this.layer.addGradation(this.position, this.color);
        // 追加したグラデーションをカレントにする
        this.layer.selectedGradationPoint = this.index;

        this.doneCallback();
    }

    public redo() : void
    {
        // グラデーション削除
        this.layer.removeGradation(this.index);
        // カレントは直前に
        var newSelectedIndex = this.index - 1;
        if(newSelectedIndex < 0) { newSelectedIndex = 0; }
        this.layer.selectedGradationPoint = newSelectedIndex;
        

        this.doneCallback();
    }
}